import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=a7ffe998&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=a7ffe998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ffe998",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7ffe998')) {
      api.createRecord('a7ffe998', component.options)
    } else {
      api.reload('a7ffe998', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=a7ffe998&scoped=true&", function () {
      api.rerender('a7ffe998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tt0K076N0Toz/JS/comp/Voucher.vue"
export default component.exports